import axios from 'axios';
import baseUrl from '../shared/baseUrl';

const api_client = axios.create({
  baseURL: `${baseUrl}/api`,
});

api_client.interceptors.request.use(
  config => {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api_client.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');

      if (!refreshToken) {
        // window.location.href = '/';
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${baseUrl}/api/auth/token/refresh/`, { refresh: refreshToken });

        localStorage.setItem('access_token', response.data.access);
        api_client.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
        originalRequest.headers['Authorization'] = `Bearer ${response.data.access}`;

        return api_client(originalRequest);
      } catch (err) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/';
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);


export default api_client;
